<template>
  <div>
    <span v-intersect="onIntersect"></span>
    <v-chip-group v-if="!loading">
      <RoomChip
        v-for="room in rooms"
        :key="'room' + room.id"
        :value="room"
      ></RoomChip>
      <ReservationChip
        v-for="reservation in reservations"
        :key="'reservation' + reservation.id"
        :value="reservation"
      ></ReservationChip>
    </v-chip-group>
    <v-chip v-else small outlined
      ><v-progress-circular
        size="14"
        width="2"
        indeterminate
      ></v-progress-circular
    ></v-chip>
  </div>
</template>

<script>
import { defineComponent } from "vue";
import ReservationChip from "common/components/ReservationChip.vue";
import RoomChip from "common/components/RoomChip.vue";

export default defineComponent({
  name: "SmartLearnRoom",
  components: { ReservationChip, RoomChip },
  props: {
    date: String,
    period: { startTime: null, endTime: null },
    course: {},
    schoolClass: {},
    person: {},
  },
  data() {
    return {
      rooms: [],
      reservations: [],
      loading: false,
      visible: false,
      abortController: null,
    };
  },
  methods: {
    onIntersect(entries) {
      // More information about these options
      // is located here: https://developer.mozilla.org/en-US/docs/Web/API/Intersection_Observer_API
      this.isIntersecting = entries[0].isIntersecting;
      if (!this.visible && this.isIntersecting) {
        this.visible = true;
        this.fetchData();
      }
    },
    async fetchData() {
      if (!this.date || !this.period) {
        return;
      }
      this.loading = true;
      if (this.abortController) {
        this.abortController.abort();
      }
      this.abortController = new AbortController();
      if (this.schoolClass && this.schoolClass.id) {
        this.register = await this.apiList({
          resource: "register/register",
          query: `schoolClass=${this.schoolClass.id}&startDate=${this.date}&startTime=${this.period.startTime}&endDate=${this.date}&endTime=${this.period.endTime}`,
          signal: this.abortController.signal,
        });
      } else if (this.person && this.person.id) {
        const type =
          this.person.type.code === "student" ? "student" : "teacher";
        this.register = await this.apiList({
          resource: "register/register",
          query: `${type}=${this.person.id}&startDate=${this.date}&startTime=${this.period.startTime}&endDate=${this.date}&endTime=${this.period.endTime}`,
          signal: this.abortController.signal,
        });
      }
      if (this.register) {
        this.rooms = this.register.days[0].lessons[0].rooms;
        this.reservations = this.register.days[0].lessons[0].reservations;
      }
      this.abortController = null;
      this.loading = false;
    },
  },
  destroyed() {
    if (this.loading && this.abortController) {
      this.visible = false;
      this.abortController.abort();
    }
  },
});
</script>
